import { useState, useEffect } from "react";

const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState(getDevice(window.innerWidth));

  function getDevice(width) {
    if (width < 600) return "mobile"; // < 420px
    if (width < 1025) return "tablet"; // 420px – 1024px
    return "laptop"; // ≥ 1025px
  }

  useEffect(() => {
    const handleResize = () => setBreakpoint(getDevice(window.innerWidth));
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return breakpoint;
};

export default useBreakpoint;
